import { gql } from "apollo-boost"

export const GET_ASSISTANTS_REPORT_URL = gql`
  query getAssistantsReportUrl($id: ID!, $filter: String) {
    generateAssistantsReportBySubmission(id: $id, filter: $filter)
  }
`
